module.exports = __webpack_public_path__ + "assets/img/farley_mowat-7d2c3f11.jpg";